import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

import LeaderBoard from "../../components/LeaderBoard/LeaderBoardContainer";
import Announcements from "../../components/Announcements/Announcements";

import RaceService from "../../services/RaceService";
import AnnouncementService from "../../services/AnnouncementseService";

function HomePageDesktop() {

    var leaderBoardRender;

    leaderBoardRender = (
        <Container fluid={true} className="home-page-desktop-container">
            <Row className="raceboard">
                <Col>
                    <LeaderBoard RaceService={RaceService} />
                </Col>
            </Row>

            <Row className="no-gutters announcements" >
                <Col>
                    <Announcements AnnouncementService={AnnouncementService} />
                </Col>
            </Row>
        </Container>
    )

    return (   
        leaderBoardRender
    );
}

export default HomePageDesktop;
